<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div class="main-container h-100">
  <!-- ============================================================== -->
  <!-- Topbar - style you can find in header.scss -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- End Topbar - style you can find in pages.scss -->
  <!-- ============================================================== -->
  <mat-sidenav-container class="example-sidenav-container">
    <!-- ============================================================== -->
    <!-- Sidebar - style you can find in sidebar.scss -->
    <!-- ============================================================== -->
    <mat-sidenav #snav id="snav" class="sidebar" [mode]="mobileQuery.matches ? 'side' : 'over'" fixedTopGap="0" [opened]="mobileQuery.matches" [disableClose]="!mobileQuery.matches">
      <div class="sidebar-close-btn" (click)="snav.toggle()" (click)="WindowResize($event)">
        <img *ngIf="isMobile == true" src="../../../assets/images/menu.svg" alt="Close" style="width: 28px; height: 28px; cursor: pointer;" loading="lazy">
      </div>
      <app-sidebar (menuItemClicked)="onSidebarMenuClick($event, snav)"></app-sidebar>
    </mat-sidenav>
    <!-- ============================================================== -->
    <!-- Sidebar - style you can find in sidebar.scss -->
    <!-- ============================================================== -->

    <!-- ============================================================== -->
    <!-- Page container - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <mat-sidenav-content class="page-wrapper">
      <div class="header-container">
        <div class="header-left">
          <a style="cursor: pointer;" (click)="snav.toggle()" (click)="WindowResize($event)" value="sidebarclosed">
            <div class="menu-icon"></div>
          </a>
          <p class="page-title">{{navName}}</p>
          
        </div>
      </div>

      <div class="page-content">
        <main>
          <router-outlet #page="outlet"></router-outlet>
        </main>
      </div>
    </mat-sidenav-content>
    <!-- ============================================================== -->
    <!-- Page container - style you can find in pages.scss -->
    <!-- ============================================================== -->
  </mat-sidenav-container>
</div>
